export default "__VITE_ASSET__afb32eb5__"